import { useQuery } from '@tanstack/react-query'
import { authorizedFetch } from '@/lib/api'

export interface EngagementCoreMetrics {
  total_users: number
  active_users: number
  signups: number | null
  recent_logins: number | null
  group_distribution: Record<string, number>
  threads: number
  threads_in_range: number | null
  feedback_items?: number
}

export interface EngagementDomainMetrics {
  kind: 'employment'
  opportunities: number
  applications: number
}

export interface EngagementReport {
  period: {
    label: string
    start: string | null
    end: string
  }
  core: EngagementCoreMetrics
  domain: EngagementDomainMetrics | null
}

export function useEngagementReport(params?: { date_range?: string }) {
  return useQuery({
    queryKey: ['engagement-report', params],
    queryFn: async (): Promise<EngagementReport> => {
      const searchParams = new URLSearchParams()
      if (params?.date_range) searchParams.append('date_range', params.date_range)

      const response = await authorizedFetch(`/api/admin/reporting?${searchParams.toString()}`)

      if (!response.ok) {
        throw new Error('Failed to fetch engagement report')
      }

      const data = await response.json()
      return data.report
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}
